
import Loading from './Loading.js';

export default {
  name: `AdminPasswordReset`,
  components: {
    Loading
  },
  data () {
    return {
      password: '',
      successMsg: null,
      errorMsg: null,
      invalidTokenError: null,
      loading: false,
      email: null
    }
  },
  computed: {
    isDisabled () {
      if (!this.password) {
        return true;
      }
      return false;
    },
    token () {
      return this.$route.params.token;
    }
  },
  methods: {
    validateToken () {
      this.loading = true;
      this.invalidTokenError = null;
      this.successMsg = null;

      this.$http.post('/auth/validate_password_reset_token', {token: this.token})
      .then((response) => {
        if (response.data.item) {
          this.invalidTokenError = null;
          this.email = response.data.item.email;
        }
        else {
          this.invalidTokenError = response.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
        this.invalidTokenError = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
    },
    postUpdatedPassword () {
      this.loading = true;
      this.errorMsg = null;
      this.successMsg = null;

      this.$http.post('/auth/reset_password_using_token', {token: this.token, password: this.password})
      .then((response) => {
        if (response.data.success) {
          this.errorMsg = null;
          this.successMsg = 'Password Updated!';
        }
        else {
          this.errorMsg = response.data.error;
        }
      })
      .catch((error) => {
        console.log(error);
        this.errorMsg = error.toString();
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    console.log('adminlogin');
    if (this.token) {
      this.validateToken();
    } 
  },
  template: `
    <div class="admin-login-component">
      <div class="innblocks-logo logo32 theme"></div>
      <loading :loading="loading"></loading>

      <h3>Update Your Password</h3>

      <p class="error" v-if="!token">
        Password reset token not found!
      </p>
      <p class="error" v-else-if="token && invalidTokenError">
        {{invalidTokenError}}
      </p>
      <p class="success" v-else-if="successMsg">
          {{successMsg}}
      </p>
      <form class="form" v-on:submit.prevent="postUpdatedPassword" v-else>
        <div class="row">
          <label class="label">
              <span class="label-text">Email Address</span>
              <span class="input-wrap">
                  {{this.email}}
              </span>
          </label>
        </div>
        <div class="row">
          <label class="label">
              <span class="label-text">Password</span>
              <span class="input-wrap">
                  <input type="password" v-model="password" />
              </span>
          </label>
        </div>
        <div class="error" v-if="errorMsg">
            {{errorMsg}}
        </div>
        <div class="row">
          <button type="submit" :disabled="isDisabled" class="button">
            <span v-if="loading">...</span>
            <span v-if="!loading">Update Password</span>
          </button>
        </div>
      </form>
      <div class="">
      <router-link :to='{name: "login"}'>Login</router-link> &nbsp; &middot; &nbsp;
      <router-link :to='{name: "signup"}'>Sign Up</router-link>
      </div>
    </div>
  `,
};